import { RouterModule, Routes } from '@angular/router';
import { HomeReportsComponent } from './components/home-reports/home-reports.component';
import { ListPeopleComponent } from './components/list-people/list-people.component';
import { ListPurchasesComponent } from './components/list-purchases/list-purchases.component';
import { PoliceReportComponent } from './components/police-report/police-report.component';
import { StatsComponent } from './components/stats/stats.component';
import { ListInvoicesComponent } from './components/list-invoices/list-invoices.component';

export const ReportsRouter: Routes = [
    { path: '', component: HomeReportsComponent },
    { path: 'people/list', component: ListPeopleComponent },
    { path: 'purchase/list', component: ListPurchasesComponent },
    { path: 'policeReport', component: PoliceReportComponent },
    { path: 'stats', component: StatsComponent },
    { path: 'invoices', component: ListInvoicesComponent }
];


// WEBPACK FOOTER //
// ./src/app/reports/reports.router.ts